var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open_vip"},[_c('div',{staticClass:"vip_top"},[_c('div',{staticClass:"title"},[_vm._v("开展全民健身 增强人民体质")]),_c('img',{attrs:{"src":require("../assets/images/vip.png"),"alt":""}})]),_c('div',{staticClass:"vip_bottom"},[_c('div',{staticClass:"title"},[_vm._v("河北省2025年国家级社会体育指导员培训！")])])])
}]

export { render, staticRenderFns }